import { translate } from 'src/app/project/features/translate/translate';
import { transformDate } from 'src/app/project/shared/date-transformer';
import { EAdvancedFilterOptions } from '../../filters-advanced/models/advanced-filter-options.enum';
import { EAdvancedFilterType } from '../../filters-advanced/models/advanced-filter-type.enum';
import {
  TAdvancedFilterDateUpdated,
  TFilterDateOptions,
  TSearchFilterRow,
} from '../../filters-advanced/models/advanced-filter.model';
import { TSearchAdvancedFilterOperator } from '../../points/point-search/point-search.consts';

export type TUpdatedDateFilterSegment = {
  condition: string;
  dates: string;
};

const optionTranslationKeys: Record<TFilterDateOptions, string> = {
  [EAdvancedFilterOptions.IS]: 'is',
  [EAdvancedFilterOptions.IS_BEFORE]: 'is_before',
  [EAdvancedFilterOptions.IS_AFTER]: 'is_after',
  [EAdvancedFilterOptions.IS_BETWEEN]: 'is_between',
  [EAdvancedFilterOptions.IS_GREATER_THAN_OR_EQUAL]: 'is_on_or_after',
  [EAdvancedFilterOptions.IS_LESS_THAN_OR_EQUAL]: 'is_on_or_before',
  [EAdvancedFilterOptions.IS_EMPTY]: 'is_empty',
  [EAdvancedFilterOptions.IS_NOT_EMPTY]: 'is_not_empty',
};

export function formatUpdatedDateFilters(
  filters: TSearchFilterRow[],
  operator: TSearchAdvancedFilterOperator,
  dateFormat: string,
): TUpdatedDateFilterSegment[] {
  const updatedDateFilters = filters
    .map((filter) => filter.item)
    .filter(
      (item): item is TAdvancedFilterDateUpdated =>
        item?.type === EAdvancedFilterType.DATE_UPDATED,
    );

  const joinWord = operator === 'OR' || operator === 'NOR' ? translate('or') : translate('and');

  return updatedDateFilters.map((filter, index) => {
    const label = translate(optionTranslationKeys[filter.option]).toLowerCase();

    return {
      condition: index === 0 ? label : `${joinWord} ${label}`,
      dates: formatDates(filter, dateFormat),
    };
  });
}

function formatDates(filter: TAdvancedFilterDateUpdated, dateFormat: string): string {
  const [startDate, endDate] = filter.value ?? [];
  const start = transformDate({ value: startDate, format: dateFormat, localTime: false });

  if (filter.option === EAdvancedFilterOptions.IS_BETWEEN) {
    const end = transformDate({ value: endDate, format: dateFormat, localTime: false });

    return `${start} - ${end}`;
  }

  return start;
}
